import axios from 'axios'

const state = () => ({
  views         : [],
  activeMenu    : 'shapes',
  addToCanvas   : null,
  selectedCase  : null,
  selectedView  : null,
  hotspotUrl    : '',
  selectedCourse: null,
  canvasObjects : [],
})

// getters
const getters = {
  views(state) {
    return state.views
  },

  selectedView(state) {
    return state.selectedView
  },

  activeMenu(state) {
    return state.activeMenu
  },

  addToCanvas(state) {
    return state.addToCanvas
  },

  selectedCase(state) {
    return state.selectedCase
  },

  hotspotUrl(state) {
    return state.hotspotUrl
  },

  selectedCourse(state) {
    return state.selectedCourse
  },

  canvasObjects(state) {
    return state.canvasObjects
  },
}

// actions
const actions = {
  onSetActiveMenu({state, commit}, menu) {
    commit('setActiveMenu', menu)
  },

  async loadViews({state, commit}, case_id) {
    try {
      const {data} = await axios.get(`/ecg/cases/${case_id}`)

      if (data.data.views) {
        const selectedCase = data.data
        const views        = data.data.views.map(view => {
          return {
            id     : view.id,
            url    : view.path,
            name   : `Default View `,
            case_id: data.data.case_uid,
            svg    : view.svg,
            json   : view.json,
          }
        })

        commit('setViews', views)
        commit('setCase', selectedCase)
      }
    } catch (e) {
      console.error(e)
    }
  },

  addToCanvas({state, commit}, element) {
    commit('setAddToCanvasElement', element)
  },

  addUrlToHotspot({state, commit}, element) {
    commit('setAddUrlToHotspotElement', element)
  },

  setViews({state, commit}, element) {
    commit('setViews', element)
  },

  setActiveView({state, commit}, element) {
    commit('setActiveView', element)
  },

  setActiveCase({state, commit}, element) {
    commit('setCase', element)
  },

  setActiveCourse({state, commit}, element) {
    commit('setCourse', element)
  },

  setCanvasObjects({state, commit}, element) {
    commit('setCanvasObjects', element)
  },

}

// mutations
const mutations = {
  setActiveMenu(state, menu) {
    if (['views', 'text', 'shapes', 'hotspots', 'canvas-objects'].includes(menu)) {
      state.activeMenu = menu
    }
  },
  setViews(state, views) {
    state.views = views
  },
  setAddToCanvasElement(state, element) {
    state.addToCanvas = element
  },
  setAddUrlToHotspotElement(state, element) {
    state.hotspotUrl = element
  },
  setCase(state, element) {
    state.selectedCase = element
  },
  setCourse(state, element) {
    state.selectedCourse = element
  },
  setActiveView(state, element) {
    state.selectedView = element
  },
  setCanvasObjects(state, element) {
    state.canvasObjects = element
  },
}

export default {
  // namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
